import React from 'react';
import TemplateEditor from './TemplateEditor';

const TemplateModal = ({ 
  show, 
  onClose, 
  template, 
  onChange, 
  onSave, 
  type // 'email', 'sms', 'layout'
}) => {
  
  if (!show || !template) return null;

  const emailTags = [
    { tag: '{nome}', label: 'Nome do Cliente' },
    { tag: '{empresa}', label: 'Nome da Empresa' },
    { tag: '{numero_doc}', label: 'Número do Documento' },
    { tag: '{valor}', label: 'Valor' },
    { tag: '{data}', label: 'Data' },
    { tag: '{hora}', label: 'Hora' },
    { tag: '{metodo}', label: 'Método de Pagamento' }
  ];

  const smsTags = [
    { tag: '{nome}', label: 'Nome' },
    { tag: '{empresa}', label: 'Empresa' },
    { tag: '{data}', label: 'Data' },
    { tag: '{hora}', label: 'Hora' }
  ];

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '20px'
      }}
      onClick={onClose}
    >
      <div 
        style={{
          background: '#fff',
          borderRadius: '16px',
          width: '100%',
          maxWidth: '800px',
          maxHeight: '90vh',
          overflow: 'auto',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
        }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{
          padding: '24px',
          borderBottom: '1px solid #e5e7eb',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
            {template.id ? '✏️ Editar Template' : '➕ Novo Template'}
          </h2>
          <button 
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#6b7280',
              padding: '0',
              width: '32px',
              height: '32px'
            }}
          >
            ×
          </button>
        </div>

        <div style={{ padding: '24px' }}>
          {/* Nome */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', marginBottom: '8px' }}>
              Nome do Template *
            </label>
            <input
              type="text"
              value={template.name || ''}
              onChange={e => onChange({ ...template, name: e.target.value })}
              placeholder={type === 'email' ? 'ex: Boas-vindas Cliente' : 
                          type === 'sms' ? 'ex: Lembrete Treino' :
                          'ex: Fatura Moderna'}
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #d1d5db',
                fontSize: '14px'
              }}
            />
          </div>

          {/* Tipo */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', marginBottom: '8px' }}>
              Tipo *
            </label>
            <select
              value={template.type || template.documentType || ''}
              onChange={e => onChange({ 
                ...template, 
                [type === 'layout' ? 'documentType' : 'type']: e.target.value 
              })}
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #d1d5db',
                fontSize: '14px'
              }}
            >
              {type === 'email' && (
                <>
                  <option value="Notificacao">Notificação</option>
                  <option value="Fatura">Fatura</option>
                  <option value="Recibo">Recibo</option>
                  <option value="Documento">Documento</option>
                  <option value="Marcacao">Marcação</option>
                  <option value="Plano">Plano de Treino</option>
                  <option value="ContaCorrente">Conta Corrente</option>
                  <option value="Pendentes">Pendentes</option>
                </>
              )}
              {type === 'sms' && (
                <>
                  <option value="Notificacao">Notificação</option>
                  <option value="Agendamento">Agendamento</option>
                  <option value="Documento">Documento</option>
                  <option value="PlanoTreino">Plano de Treino</option>
                  <option value="PlanoAlimentar">Plano Alimentar</option>
                </>
              )}
              {type === 'layout' && (
                <>
                  <option value="FT">Fatura (FT)</option>
                  <option value="RC">Recibo (RC)</option>
                  <option value="GR">Guia Remessa (GR)</option>
                  <option value="MS">Movimento Stock (MS)</option>
                  <option value="INV">Inventário (INV)</option>
                </>
              )}
            </select>
          </div>

          {/* Assunto (apenas Email) */}
          {type === 'email' && (
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', marginBottom: '8px' }}>
                Assunto do Email *
              </label>
              <input
                type="text"
                value={template.subject || ''}
                onChange={e => onChange({ ...template, subject: e.target.value })}
                placeholder="ex: Bem-vindo à {empresa}!"
                style={{
                  width: '100%',
                  padding: '12px',
                  borderRadius: '8px',
                  border: '1px solid #d1d5db',
                  fontSize: '14px'
                }}
              />
            </div>
          )}

          {/* Corpo (Email e SMS) */}
          {(type === 'email' || type === 'sms') && (
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', marginBottom: '8px' }}>
                {type === 'email' ? 'Corpo do Email (HTML)' : 'Mensagem SMS (max 160 caracteres)'}
              </label>
              <TemplateEditor
                value={template.body || ''}
                onChange={value => onChange({ ...template, body: value })}
                availableTags={type === 'email' ? emailTags : smsTags}
                type={type}
              />
              {type === 'sms' && (
                <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
                  Caracteres: {(template.body || '').length} / 160
                </div>
              )}
            </div>
          )}

          {/* Configurações de Layout */}
          {type === 'layout' && (
            <>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '20px' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', marginBottom: '8px' }}>
                    Tamanho Papel
                  </label>
                  <select
                    value={template.paperSize || 'A4'}
                    onChange={e => onChange({ ...template, paperSize: e.target.value })}
                    style={{
                      width: '100%',
                      padding: '12px',
                      borderRadius: '8px',
                      border: '1px solid #d1d5db'
                    }}
                  >
                    <option value="A4">A4</option>
                    <option value="A5">A5</option>
                    <option value="Letter">Letter</option>
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', marginBottom: '8px' }}>
                    Tamanho Fonte
                  </label>
                  <input
                    type="number"
                    value={template.fontSize || 12}
                    onChange={e => onChange({ ...template, fontSize: parseInt(e.target.value) })}
                    min="8"
                    max="24"
                    style={{
                      width: '100%',
                      padding: '12px',
                      borderRadius: '8px',
                      border: '1px solid #d1d5db'
                    }}
                  />
                </div>
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', marginBottom: '8px' }}>
                  Cor Principal
                </label>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                  <input
                    type="color"
                    value={template.primaryColor || '#3498db'}
                    onChange={e => onChange({ ...template, primaryColor: e.target.value })}
                    style={{ width: '60px', height: '40px', borderRadius: '8px', border: '1px solid #d1d5db' }}
                  />
                  <input
                    type="text"
                    value={template.primaryColor || '#3498db'}
                    onChange={e => onChange({ ...template, primaryColor: e.target.value })}
                    placeholder="#3498db"
                    style={{
                      flex: 1,
                      padding: '12px',
                      borderRadius: '8px',
                      border: '1px solid #d1d5db'
                    }}
                  />
                </div>
              </div>
            </>
          )}

          {/* Marcar como padrão */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={template.isDefault || false}
                onChange={e => onChange({ ...template, isDefault: e.target.checked })}
                style={{ width: '18px', height: '18px' }}
              />
              <span style={{ fontSize: '14px', fontWeight: '500' }}>
                ⭐ Marcar como template padrão para este tipo
              </span>
            </label>
          </div>

          {/* Ativo */}
          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={template.isActive !== false}
                onChange={e => onChange({ ...template, isActive: e.target.checked })}
                style={{ width: '18px', height: '18px' }}
              />
              <span style={{ fontSize: '14px', fontWeight: '500' }}>
                ✅ Template ativo
              </span>
            </label>
          </div>

          {/* Botões */}
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
            <button
              className="btn-secondary"
              onClick={onClose}
              style={{ padding: '12px 24px' }}
            >
              Cancelar
            </button>
            <button
              className="btn-primary"
              onClick={onSave}
              style={{ padding: '12px 24px' }}
            >
              💾 Guardar Template
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplateModal;
